import React from 'react';
import PropTypes from 'prop-types';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import StateSelect from 'components/state_select';
import SubsectionItem from 'bundles/backoffice/contacts/forms/subsection_item';
import { Form } from 'react-bootstrap-5';

// TODO: Full country support like the non-react version
export default class Address extends React.Component {
  static propTypes = {
    address: PropTypes.shape({
      city: PropTypes.string,
      label: PropTypes.string,
      primary: PropTypes.bool,
      state: PropTypes.string,
      zip: PropTypes.string
    }).isRequired,
    onChange: PropTypes.func.isRequired
  }

  handleChange = (changes) => {
    this.props.onChange(changes, this.props.address);
  }

  handleStateChange = (event) => {
    const { value } = event.target;
    this.props.onChange({ state: value }, this.props.address);
  }

  handleDelete = () => {
    this.props.onChange({ _destroy: true }, this.props.address);
  }

  makePrimary = () => {
    this.props.onChange({ primary: true }, this.props.address);
  }

  render() {
    return (
      <SubsectionItem
        label="Address"
        labelClassName="fs-large"
        primary={this.props.address.primary}
        onPrimaryChange={this.makePrimary}
        onRemove={this.handleDelete}
      >
        {this.renderForm()}
      </SubsectionItem>
    );
  }

  renderForm() {
    return (
      <div>
        {this.renderFormGroup('label', 'Address name', { placeholder: 'Ex. Buildout, Inc.' })}
        {this.renderFormGroup('addressOne', 'Address line 1', { placeholder: 'Ex. 10 N Street' })}
        {this.renderFormGroup('addressTwo', 'Address line 2', { placeholder: 'Ex. Unit 8' })}
        {this.renderFormGroup('city', 'City', { placeholder: 'Ex. Chicago' })}

        <div className="d-flex align-items-center gap-3 mt-3">
          <div className="d-flex flex-column gap-1">
            <Form.Label>State</Form.Label>
            <div className="form-input-container">
              <StateSelect
                className="form-select short-input"
                includeBlank="Ex. IL - Illinois"
                name="state"
                value={this.props.address.state}
                onChange={this.handleStateChange}
              />
            </div>
          </div>

          {this.renderFormGroup('zip', 'Zip', { placeholder: 'Ex. 60610' })}
        </div>        
      </div>
    );
  }

  renderFormGroup(name, label, props = {}) {
    return (
      <ManagedFormGroup
        {...props}
        autoComplete="off"
        label={label}
        name={name}
        value={this.props.address[name]}
        onChange={this.handleChange}
      />
    );
  }
}
